// Initialize variables
var resultSlider = document.getElementById('resultSlider');
var sliderHandle = document.getElementById('sliderHandle');
var sliderOverlay = document.getElementById('sliderOverlay');
var isDragging = false;

// ==========================================
// SCROLL REVEAL ANIMATION
// ==========================================
var observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
};

var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            entry.target.classList.add('active');
        }
    });
}, observerOptions);

var revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
revealElements.forEach(function(el) {
    revealObserver.observe(el);
});

// ==========================================
// BEFORE/AFTER SLIDER
// ==========================================
if (resultSlider && sliderHandle && sliderOverlay) {
    function updateSliderPosition(clientX) {
        var rect = resultSlider.getBoundingClientRect();
        var position = (clientX - rect.left) / rect.width;
        position = Math.max(0, Math.min(1, position));
        
        sliderOverlay.style.width = (position * 100) + '%';
        sliderHandle.style.left = (position * 100) + '%';
    }

    sliderHandle.addEventListener('mousedown', function(e) {
        isDragging = true;
        e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
        if (isDragging) {
            updateSliderPosition(e.clientX);
        }
    });

    document.addEventListener('mouseup', function() {
        isDragging = false;
    });

    // Touch support
    sliderHandle.addEventListener('touchstart', function(e) {
        isDragging = true;
    });

    document.addEventListener('touchmove', function(e) {
        if (isDragging && e.touches[0]) {
            updateSliderPosition(e.touches[0].clientX);
        }
    });

    document.addEventListener('touchend', function() {
        isDragging = false;
    });

    // Click on slider to move handle
    resultSlider.addEventListener('click', function(e) {
        updateSliderPosition(e.clientX);
    });
}

// ==========================================
// FAQ ACCORDION
// ==========================================
var faqItems = document.querySelectorAll('.faq-item');
faqItems.forEach(function(item) {
    var question = item.querySelector('.faq-question');
    question.addEventListener('click', function() {
        // Close all other items
        faqItems.forEach(function(otherItem) {
            if (otherItem !== item) {
                otherItem.classList.remove('active');
            }
        });
        // Toggle current item
        item.classList.toggle('active');
    });
});

// ==========================================
// SKIN TYPE TABS
// ==========================================
var skintypeTabs = document.querySelectorAll('.skintype-tab');
var skintypeContents = document.querySelectorAll('.skintype-content');

skintypeTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
        var targetTab = this.getAttribute('data-tab');
        
        // Remove active from all tabs
        skintypeTabs.forEach(function(t) {
            t.classList.remove('active');
        });
        
        // Add active to clicked tab
        this.classList.add('active');
        
        // Hide all content
        skintypeContents.forEach(function(content) {
            content.classList.remove('active');
        });
        
        // Show target content
        var targetContent = document.getElementById('tab-' + targetTab);
        if (targetContent) {
            targetContent.classList.add('active');
        }
    });
});

// ==========================================
// COUNTER ANIMATION
// ==========================================
var counterObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            var counterElement = entry.target;
            var target = parseInt(counterElement.getAttribute('data-target'), 10);
            var current = 0;
            var increment = target / 50;
            
            function updateCounter() {
                current += increment;
                if (current < target) {
                    counterElement.textContent = Math.floor(current);
                    requestAnimationFrame(updateCounter);
                } else {
                    counterElement.textContent = target;
                }
            }
            
            updateCounter();
            counterObserver.unobserve(counterElement);
        }
    });
}, { threshold: 0.5 });

var counters = document.querySelectorAll('.sustainability-number');
counters.forEach(function(counter) {
    counterObserver.observe(counter);
});

// ==========================================
// SMOOTH SCROLL FOR ANCHOR LINKS
// ==========================================
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = this.getAttribute('href');
        var targetElement = document.querySelector(targetId);
        
        if (targetElement) {
            var headerOffset = 80;
            var elementPosition = targetElement.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    });
});